import { apiClientAudio } from '@/plugins/axios'

export default {
  getAllRegex() {
    return apiClientAudio().get('/alliasregex')
  },
  getOneRegex(id) {
    return apiClientAudio().get(`/alliasregex/${id}`)
  },
  postRegex(regex) {
    let formData = new FormData()
    formData.append('description', regex.description)
    formData.append('import', regex.import)
    formData.append('regexs', JSON.stringify({ regexs: regex.regex }))

    return apiClientAudio().post('/alliasregex', formData)
  },
  putRegex(id, regex) {
    let formData = new FormData()
    formData.append('description', regex.description)
    formData.append('import', regex.import)
    formData.append('regexs', JSON.stringify({ regexs: regex.regex }))

    return apiClientAudio().post(`/alliasregex/${id}?_method=PUT`, formData)
  },
  deleteRegex(id) {
    return apiClientAudio().delete(`/alliasregex/${id}`)
  },
}
